export { default as AccelerateLarge } from './AccelerateLarge';
export { default as AccelerateSmall } from './AccelerateSmall';
export { default as AddNoteLarge } from './AddNoteLarge';
export { default as AddNoteSmall } from './AddNoteSmall';
export { default as AddToDxLarge } from './AddToDxLarge';
export { default as AddToDxSmall } from './AddToDxSmall';
export { default as AllergyLarge } from './AllergyLarge';
export { default as AllergySmall } from './AllergySmall';
export { default as AnticlockwiseLarge } from './AnticlockwiseLarge';
export { default as AnticlockwiseSmall } from './AnticlockwiseSmall';
export { default as AppointmentLarge } from './AppointmentLarge';
export { default as AppointmentSmall } from './AppointmentSmall';
export { default as ArchiveLarge } from './ArchiveLarge';
export { default as ArchiveSmall } from './ArchiveSmall';
export { default as ArrowDownLarge } from './ArrowDownLarge';
export { default as ArrowDownSmall } from './ArrowDownSmall';
export { default as ArrowLeftLarge } from './ArrowLeftLarge';
export { default as ArrowLeftSmall } from './ArrowLeftSmall';
export { default as ArrowRightLarge } from './ArrowRightLarge';
export { default as ArrowRightSmall } from './ArrowRightSmall';
export { default as ArrowUpLarge } from './ArrowUpLarge';
export { default as ArrowUpSmall } from './ArrowUpSmall';
export { default as AttachmentLarge } from './AttachmentLarge';
export { default as AttachmentSmall } from './AttachmentSmall';
export { default as AttentionButtonLarge } from './AttentionButtonLarge';
export { default as AttentionButtonSmall } from './AttentionButtonSmall';
export { default as AttentionLarge } from './AttentionLarge';
export { default as AttentionSimpleLarge } from './AttentionSimpleLarge';
export { default as AttentionSimpleSmall } from './AttentionSimpleSmall';
export { default as AttentionSmall } from './AttentionSmall';
export { default as BoldLarge } from './BoldLarge';
export { default as BoldSmall } from './BoldSmall';
export { default as BoltLarge } from './BoltLarge';
export { default as BoltSmall } from './BoltSmall';
export { default as BugLarge } from './BugLarge';
export { default as BugSmall } from './BugSmall';
export { default as CalendarLarge } from './CalendarLarge';
export { default as CalendarSmall } from './CalendarSmall';
export { default as CallLarge } from './CallLarge';
export { default as CallSmall } from './CallSmall';
export { default as CameraLarge } from './CameraLarge';
export { default as CameraSmall } from './CameraSmall';
export { default as ChartLarge } from './ChartLarge';
export { default as ChartSmall } from './ChartSmall';
export { default as ChatLarge } from './ChatLarge';
export { default as ChatSmall } from './ChatSmall';
export { default as CheckInLarge } from './CheckInLarge';
export { default as CheckInSmall } from './CheckInSmall';
export { default as CheckLarge } from './CheckLarge';
export { default as CheckSmall } from './CheckSmall';
export { default as ClearbackLarge } from './ClearbackLarge';
export { default as ClearbackSmall } from './ClearbackSmall';
export { default as ClockLarge } from './ClockLarge';
export { default as ClockSmall } from './ClockSmall';
export { default as ClockwiseLarge } from './ClockwiseLarge';
export { default as ClockwiseSmall } from './ClockwiseSmall';
export { default as CloseLarge } from './CloseLarge';
export { default as CloseSmall } from './CloseSmall';
export { default as CollapseLarge } from './CollapseLarge';
export { default as CollapseSmall } from './CollapseSmall';
export { default as ComposeLarge } from './ComposeLarge';
export { default as ComposeSmall } from './ComposeSmall';
export { default as CopyLarge } from './CopyLarge';
export { default as CopySmall } from './CopySmall';
export { default as CriticalLarge } from './CriticalLarge';
export { default as CriticalSmall } from './CriticalSmall';
export { default as DesktopLarge } from './DesktopLarge';
export { default as DesktopSmall } from './DesktopSmall';
export { default as DivergeLarge } from './DivergeLarge';
export { default as DivergeSmall } from './DivergeSmall';
export { default as DoctorsBagLarge } from './DoctorsBagLarge';
export { default as DoctorsBagSmall } from './DoctorsBagSmall';
export { default as DocumentLarge } from './DocumentLarge';
export { default as DocumentSmall } from './DocumentSmall';
export { default as DollarLarge } from './DollarLarge';
export { default as DollarSmall } from './DollarSmall';
export { default as DownloadLarge } from './DownloadLarge';
export { default as DownloadSmall } from './DownloadSmall';
export { default as DragLarge } from './DragLarge';
export { default as DragSmall } from './DragSmall';
export { default as DrawLarge } from './DrawLarge';
export { default as DrawSmall } from './DrawSmall';
export { default as EditLarge } from './EditLarge';
export { default as EditSmall } from './EditSmall';
export { default as EmergencyLarge } from './EmergencyLarge';
export { default as EmergencySmall } from './EmergencySmall';
export { default as ExpandLarge } from './ExpandLarge';
export { default as ExpandSmall } from './ExpandSmall';
export { default as ExportLarge } from './ExportLarge';
export { default as ExportSmall } from './ExportSmall';
export { default as FeedbackLarge } from './FeedbackLarge';
export { default as FeedbackSmall } from './FeedbackSmall';
export { default as FilterActiveLarge } from './FilterActiveLarge';
export { default as FilterActiveSmall } from './FilterActiveSmall';
export { default as FilterLarge } from './FilterLarge';
export { default as FilterSmall } from './FilterSmall';
export { default as FirstPageLarge } from './FirstPageLarge';
export { default as FirstPageSmall } from './FirstPageSmall';
export { default as FishboneLarge } from './FishboneLarge';
export { default as FishboneSmall } from './FishboneSmall';
export { default as FlagLarge } from './FlagLarge';
export { default as FlagSmall } from './FlagSmall';
export { default as FlipCameraLarge } from './FlipCameraLarge';
export { default as FlipCameraSmall } from './FlipCameraSmall';
export { default as FullScreenLarge } from './FullScreenLarge';
export { default as FullScreenSmall } from './FullScreenSmall';
export { default as GraphLarge } from './GraphLarge';
export { default as GraphSmall } from './GraphSmall';
export { default as GridLarge } from './GridLarge';
export { default as GridSmall } from './GridSmall';
export { default as HeartEmptyLarge } from './HeartEmptyLarge';
export { default as HeartEmptySmall } from './HeartEmptySmall';
export { default as HeartFilledLarge } from './HeartFilledLarge';
export { default as HeartFilledSmall } from './HeartFilledSmall';
export { default as HelpButtonLarge } from './HelpButtonLarge';
export { default as HelpButtonSmall } from './HelpButtonSmall';
export { default as HelpLarge } from './HelpLarge';
export { default as HelpSimpleLarge } from './HelpSimpleLarge';
export { default as HelpSimpleSmall } from './HelpSimpleSmall';
export { default as HelpSmall } from './HelpSmall';
export { default as HideLarge } from './HideLarge';
export { default as HideSmall } from './HideSmall';
export { default as HomeLarge } from './HomeLarge';
export { default as HomeSmall } from './HomeSmall';
export { default as HospitalLarge } from './HospitalLarge';
export { default as HospitalSmall } from './HospitalSmall';
export { default as ImageLarge } from './ImageLarge';
export { default as ImageSmall } from './ImageSmall';
export { default as InfoButtonLarge } from './InfoButtonLarge';
export { default as InfoButtonSmall } from './InfoButtonSmall';
export { default as InfoLarge } from './InfoLarge';
export { default as InfoSimpleLarge } from './InfoSimpleLarge';
export { default as InfoSimpleSmall } from './InfoSimpleSmall';
export { default as InfoSmall } from './InfoSmall';
export { default as InsertLarge } from './InsertLarge';
export { default as InsertSmall } from './InsertSmall';
export { default as ItalicLarge } from './ItalicLarge';
export { default as ItalicSmall } from './ItalicSmall';
export { default as LabsLarge } from './LabsLarge';
export { default as LabsSmall } from './LabsSmall';
export { default as LastPageLarge } from './LastPageLarge';
export { default as LastPageSmall } from './LastPageSmall';
export { default as LeaveLarge } from './LeaveLarge';
export { default as LeaveSmall } from './LeaveSmall';
export { default as LeftLarge } from './LeftLarge';
export { default as LeftSmall } from './LeftSmall';
export { default as LeversLarge } from './LeversLarge';
export { default as LeversSmall } from './LeversSmall';
export { default as LinkLarge } from './LinkLarge';
export { default as LinkSmall } from './LinkSmall';
export { default as ListBulletedLarge } from './ListBulletedLarge';
export { default as ListBulletedSmall } from './ListBulletedSmall';
export { default as ListNumberedLarge } from './ListNumberedLarge';
export { default as ListNumberedSmall } from './ListNumberedSmall';
export { default as MailLarge } from './MailLarge';
export { default as MailSmall } from './MailSmall';
export { default as MapLarge } from './MapLarge';
export { default as MapSmall } from './MapSmall';
export { default as MedicationLarge } from './MedicationLarge';
export { default as MedicationSmall } from './MedicationSmall';
export { default as MegaphoneLarge } from './MegaphoneLarge';
export { default as MegaphoneSmall } from './MegaphoneSmall';
export { default as MenuLarge } from './MenuLarge';
export { default as MenuSmall } from './MenuSmall';
export { default as MergeLarge } from './MergeLarge';
export { default as MergeSmall } from './MergeSmall';
export { default as MicrophoneOffLarge } from './MicrophoneOffLarge';
export { default as MicrophoneOffSmall } from './MicrophoneOffSmall';
export { default as MicrophoneOnLarge } from './MicrophoneOnLarge';
export { default as MicrophoneOnSmall } from './MicrophoneOnSmall';
export { default as MinusButtonLarge } from './MinusButtonLarge';
export { default as MinusButtonSmall } from './MinusButtonSmall';
export { default as MinusLarge } from './MinusLarge';
export { default as MinusSmall } from './MinusSmall';
export { default as MobileLarge } from './MobileLarge';
export { default as MobileSmall } from './MobileSmall';
export { default as ModalPopupLarge } from './ModalPopupLarge';
export { default as ModalPopupSmall } from './ModalPopupSmall';
export { default as MoreHorizontalLarge } from './MoreHorizontalLarge';
export { default as MoreHorizontalSmall } from './MoreHorizontalSmall';
export { default as MoreVerticalLarge } from './MoreVerticalLarge';
export { default as MoreVerticalSmall } from './MoreVerticalSmall';
export { default as NotAllowedLarge } from './NotAllowedLarge';
export { default as NotAllowedSmall } from './NotAllowedSmall';
export { default as NoteAddedLarge } from './NoteAddedLarge';
export { default as NoteAddedSmall } from './NoteAddedSmall';
export { default as NoteLarge } from './NoteLarge';
export { default as NoteSmall } from './NoteSmall';
export { default as NotificationBellLarge } from './NotificationBellLarge';
export { default as NotificationBellSmall } from './NotificationBellSmall';
export { default as PanelLeftLarge } from './PanelLeftLarge';
export { default as PanelLeftSmall } from './PanelLeftSmall';
export { default as PanelRightLarge } from './PanelRightLarge';
export { default as PanelRightSmall } from './PanelRightSmall';
export { default as PaymentMethodsLarge } from './PaymentMethodsLarge';
export { default as PaymentMethodsSmall } from './PaymentMethodsSmall';
export { default as PharmacyLarge } from './PharmacyLarge';
export { default as PharmacySmall } from './PharmacySmall';
export { default as PinEmptyLarge } from './PinEmptyLarge';
export { default as PinEmptySmall } from './PinEmptySmall';
export { default as PinFilledLarge } from './PinFilledLarge';
export { default as PinFilledSmall } from './PinFilledSmall';
export { default as PlusButtonLarge } from './PlusButtonLarge';
export { default as PlusButtonSmall } from './PlusButtonSmall';
export { default as PlusLarge } from './PlusLarge';
export { default as PlusSmall } from './PlusSmall';
export { default as PrintLarge } from './PrintLarge';
export { default as PrintSmall } from './PrintSmall';
export { default as ProfileLarge } from './ProfileLarge';
export { default as ProfileSmall } from './ProfileSmall';
export { default as ProviderLarge } from './ProviderLarge';
export { default as ProviderSmall } from './ProviderSmall';
export { default as QualityLarge } from './QualityLarge';
export { default as QualitySmall } from './QualitySmall';
export { default as ReceiptLarge } from './ReceiptLarge';
export { default as ReceiptSmall } from './ReceiptSmall';
export { default as RecentLarge } from './RecentLarge';
export { default as RecentSmall } from './RecentSmall';
export { default as RefreshLarge } from './RefreshLarge';
export { default as RefreshSmall } from './RefreshSmall';
export { default as RegulatoryLarge } from './RegulatoryLarge';
export { default as RegulatorySmall } from './RegulatorySmall';
export { default as RemoveAttachmentLarge } from './RemoveAttachmentLarge';
export { default as RemoveAttachmentSmall } from './RemoveAttachmentSmall';
export { default as RemoveFormattingLarge } from './RemoveFormattingLarge';
export { default as RemoveFormattingSmall } from './RemoveFormattingSmall';
export { default as RemoveLinkLarge } from './RemoveLinkLarge';
export { default as RemoveLinkSmall } from './RemoveLinkSmall';
export { default as ReverseCheckLarge } from './ReverseCheckLarge';
export { default as ReverseCheckSmall } from './ReverseCheckSmall';
export { default as RightLarge } from './RightLarge';
export { default as RightSmall } from './RightSmall';
export { default as SearchLarge } from './SearchLarge';
export { default as SearchSmall } from './SearchSmall';
export { default as SendLarge } from './SendLarge';
export { default as SendSmall } from './SendSmall';
export { default as SettingsLarge } from './SettingsLarge';
export { default as SettingsSmall } from './SettingsSmall';
export { default as ShareLarge } from './ShareLarge';
export { default as ShareSmall } from './ShareSmall';
export { default as ShowLarge } from './ShowLarge';
export { default as ShowSmall } from './ShowSmall';
export { default as SignatureLarge } from './SignatureLarge';
export { default as SignatureSmall } from './SignatureSmall';
export { default as SparkleLarge } from './SparkleLarge';
export { default as SparkleSmall } from './SparkleSmall';
export { default as SpeakerOffLarge } from './SpeakerOffLarge';
export { default as SpeakerOffSmall } from './SpeakerOffSmall';
export { default as SpeakerOnLarge } from './SpeakerOnLarge';
export { default as SpeakerOnSmall } from './SpeakerOnSmall';
export { default as StandardScreenLarge } from './StandardScreenLarge';
export { default as StandardScreenSmall } from './StandardScreenSmall';
export { default as StarEmptyLarge } from './StarEmptyLarge';
export { default as StarEmptySmall } from './StarEmptySmall';
export { default as StarFilledLarge } from './StarFilledLarge';
export { default as StarFilledSmall } from './StarFilledSmall';
export { default as StartScreenShareLarge } from './StartScreenShareLarge';
export { default as StartScreenShareSmall } from './StartScreenShareSmall';
export { default as StopScreenShareFilledLarge } from './StopScreenShareFilledLarge';
export { default as StopScreenShareFilledSmall } from './StopScreenShareFilledSmall';
export { default as SuccessLarge } from './SuccessLarge';
export { default as SuccessSmall } from './SuccessSmall';
export { default as SwitchViewLarge } from './SwitchViewLarge';
export { default as SwitchViewSmall } from './SwitchViewSmall';
export { default as TeamLarge } from './TeamLarge';
export { default as TeamSmall } from './TeamSmall';
export { default as TranslateLarge } from './TranslateLarge';
export { default as TranslateSmall } from './TranslateSmall';
export { default as TrashLarge } from './TrashLarge';
export { default as TrashSmall } from './TrashSmall';
export { default as UnderlineLarge } from './UnderlineLarge';
export { default as UnderlineSmall } from './UnderlineSmall';
export { default as UnpinLarge } from './UnpinLarge';
export { default as UnpinSmall } from './UnpinSmall';
export { default as UploadLarge } from './UploadLarge';
export { default as UploadSmall } from './UploadSmall';
export { default as VaccineLarge } from './VaccineLarge';
export { default as VaccineSmall } from './VaccineSmall';
export { default as VideoOffLarge } from './VideoOffLarge';
export { default as VideoOffSmall } from './VideoOffSmall';
export { default as VideoOnLarge } from './VideoOnLarge';
export { default as VideoOnSmall } from './VideoOnSmall';
export { default as VitalsLarge } from './VitalsLarge';
export { default as VitalsSmall } from './VitalsSmall';
export { default as XRayLarge } from './XRayLarge';
export { default as XRaySmall } from './XRaySmall';
export { default as ZoomInLarge } from './ZoomInLarge';
export { default as ZoomInSmall } from './ZoomInSmall';
export { default as ZoomOutLarge } from './ZoomOutLarge';
export { default as ZoomOutSmall } from './ZoomOutSmall';
